/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import * as constants from 'data/constants/api';

export const clear = () => ({ type: constants.CLEAR });
